/* =========================================================
 * ユーティリティ
 * ======================================================= */

/* --- 先頭1書記素（アイコン用） --- */
const firstGrapheme = (s: string): string => {
  if (!s) return "";
  try {
    const Seg: any = (Intl as any)?.Segmenter;
    if (Seg) {
      const seg = new Seg("ja", { granularity: "grapheme" });
      const it = (seg.segment(s) as any)[Symbol.iterator]();
      const first = it.next();
      if (!first?.done && first?.value?.segment) {
        return String(first.value.segment);
      }
    }
  } catch {
    // no-op
  }
  return Array.from(s)[0] ?? "";
};
// ユーザー名のイニシャルを取得
export const displayUserInitial = (name: string): string => {
  const base = String(name ?? "").normalize("NFKC").trim();
  if (!base) return "";
  const parts = base.split(/\u3000+|\s+/);
  const lastName = parts[0] || base;
  return firstGrapheme(lastName);
};

export const normStr = (v: any) => String(v ?? "").normalize("NFKC").trim();

export const normEmail = (v: any) => normStr(v).toLowerCase();

export const normNameKey = (v: any) => normStr(v).replace(/\s+/g, "");

/* --- email 比較（大小文字無視・前後空白除去） --- */
export const emailEq = (a?: string | null, b?: string | null) =>
  normEmail(a) === normEmail(b);

export const stripEmailDomain = (email: string) =>
  String(email ?? "").trim().replace(/@.*$/, "");

export const isJapaneseText = (s: string) =>
  /[^\u0000-\u007F]/.test(String(s ?? ""));

export const toHiragana = (s: string) =>
  String(s ?? "").replace(/[\u30A1-\u30F6]/g, (ch) =>
    String.fromCharCode(ch.charCodeAt(0) - 0x60)
  );
